import * as React from 'react';
import ListEvent from '../components/list/event';
import { ListContainerProps } from '../components/list/container';

const ListMonthsContainerView: React.StatelessComponent<ListContainerProps> = props => {

    return (
        <div className={`buy-tickets`} id="buyTicketsContainer">
            {
                (props.showPosterInfo !== null) ?
                    <div className={`buy-tickets-poster adage-themed ${(props.showPosterInfo !== null) ? props.showPosterInfo.theme : ""}`} id="buyTicketsPoster">
                        <div className="show-listing-item-inner buy-tickets-poster-inner">
                            <div className="show-listing-thumbnail-container">
                                <div className="show-listing-image">
                                    <img src={props.thumbnailImage} alt="" role="presentation"/>
                                </div>
                            </div>
                            <div className="show-listing-item-content">
                                <h3 className="show-listing-item-heading">{props.showPosterInfo.heading}</h3>
                                <p className="show-listing-composer">{props.showPosterInfo.composer}</p>
                                <p className="show-listing-dates">{props.showPosterInfo.dateRange}</p>
                                <div className="show-listing-links">
                                    <p>
                                        <a className="btn" href={props.showPosterInfo.learnMoreUrl}>Learn more {(props.showPosterInfo.productionTitleImageAltText !== "") ? <span className="visually-hidden">about {props.showPosterInfo.productionTitleImageAltText}</span> : ""}</a>
                                    </p>
                                    {
                                        (props.showPosterInfo.showBuyTicketsCta) ?
                                            <p>
                                                <a className="btn" href={props.showPosterInfo.buyTicketsUrl}>{props.showPosterInfo.buyTicketsCTAText}</a>
                                            </p>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }
            <div className="buy-tickets-content">
                <h2 className="visually-hidden" id="buyTicketsListHeading">Event listing</h2>
                <ul id="buyTicketsList" className="buy-tickets-list" aria-labelledby="buyTicketsListHeading">
                    {
                        props.events.map((event, index) => <ListEvent key={event.id} event={event} cssClass={(index > props.itemsToShow - 1) ? props.itemToHideCssClass : ""} />)
                    }
                </ul>
                {
                    (props.events.length > props.itemsToShow) ? <p className="buy-tickets-loadmore"><button onClick={(e) => { props.showMore(e) }} className="btn-expand">Load More</button></p> : ""
                }
            </div>
        </div>
    );
}

export default ListMonthsContainerView;